export const TabContainerTracking = {
    xs: 8
}
export const TabContainerReassign = {
    xs: 12
}